// extracted by mini-css-extract-plugin
export default {"wrapper":"dashboard_wrapper__NPwfj","salutation":"dashboard_salutation__b4bBv"};